module.exports = __webpack_public_path__ + "img/20@3x.b226e591.png";